import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const help_and_supportApi = createAsyncThunk("help_and_support", async () => {
  const response = await axiosInstance.get("/getAllTickets");
  return response.data;
});

const help_and_supportSlice = createSlice({
  name: "help_and_support",
  initialState: {
    help_and_support: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(help_and_supportApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(help_and_supportApi.fulfilled, (state, action) => {
        state.help_and_support = action.payload;
        state.loading = false;
      })
      .addCase(help_and_supportApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default help_and_supportSlice.reducer;
